import LandingNav from "../components/LandingNav";
import Title from "../components/title";
import "./createMangelanding.css";
import LandingFooter from "../components/LandingFooter";
import LandingInfo from "../components/LandingInfo";
import OurSystemContainer from "../components/OurSystemContainer";
import BenefitsConatiner from "../components/BenefitsConatiner";
import Stars from "../components/Stars";
import { ReactComponent as Loans } from './images/loans.svg';

function WebsiteLanding() {
  const textData = [
    "إنشاء موقع إلكتروني للجمعية بسهولة دون تعقيد",
    "تصميم يناسب احتياجات وأهداف كل جمعية",
    "أدوات مخصصة لعرض الأنشطة وجذب الداعمين",
    "وصول أسهل للجمهور وزيادة التفاعل مع خدمات الجمعية",
  ];

  const cardItems = [
    {
      text: "يمكنك إنشاء موقعك الإلكتروني الخاص بكل سهولة ومرونة، مع تخصيصه بما يتناسب مع احتياجات جمعيتك وأهدافها.",
      // text: "نُوفّر خدمات التصميم والتسويق للجمعيات الخيرية باشتراك الثلاث اعوام لضمان تجربة متكاملة ودعم مستمر.",
      // price: "5000",
      price: "يتم تحديد السعر علي حسب احتياجات كل موقع ",
      list: [
        "إنشاء الموقع الخاص بك بسهولة وبدون تعقيد",
        "تخصيص التصميم ليتناسب مع هوية الجمعية",
        "تحديد العناصر المناسبة التي تلبي احتياجات جمعيتك",
      ]
    },
  ];



  return (
    <div className="createMangeLand">
      <LandingNav />
      <div className="landingTitleCon">
        <Title title="انشي موقعك الالكتروني" />
      </div>

      <div className="section1Container" id="mainLandingsec1">
        <div className="homeCover">
          <h3>
            انشي موقعك الالكتروني
          </h3>
          <p>
            نُمكنك من إنشاء موقع إلكتروني للجمعية الخيرية يعكس أهدافها ويعزز حضورها الرقمي.          </p>
          <span className="lineLand"> </span>
        </div>


        <Loans />

      </div>
      <div className="starsContainer">
        <Stars />

        <LandingInfo
          text={textData}
          title="أنشئ موقع جمعيتك الإلكتروني بسهولة واحترافية"
        />

        <OurSystemContainer items={cardItems} />




        <BenefitsConatiner
          title="أساليب مبتكرة ومُلهمة لتعزيز التواصل، التفاعل، والإنتاجية."
          benTitle="مع خدمة المشاركة من Your Gates"
          benDesc="يمكنك الاستفادة من خدماتنا المتخصصة في إدارة وتسويق المشاريع، بالإضافة إلى تصميم وتنفيذ حلول مبتكرة تلبي احتياجاتك. نحرص على تقديم خدمات عالية الكفاءة والاحترافية لمساعدتك في تحقيق نجاح أعمالك بسهولة."
        />
      </div>
      <LandingFooter />
    </div>
  );
}

export default WebsiteLanding;
